import React, { useState, useEffect } from 'react';
import { getEncuestas, verificarEstadoVoto } from '../services/encuestas';
import { getIdentifiers } from '../services/fingerprint';
import EncuestaCard from '../components/EncuestaCard';
import Loading from '../components/Loading';
import ErrorMessage from '../components/ErrorMessage';
import './HomePage.css';

/**
 * Página principal - Listado de encuestas disponibles
 */
const HomePage = () => {
  const [encuestas, setEncuestas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [estadosVoto, setEstadosVoto] = useState({});

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Generar identificadores
        const ids = await getIdentifiers();

        // Cargar encuestas
        const data = await getEncuestas();
        setEncuestas(data);

        // Verificar estado de voto para cada encuesta
        const estados = {};
        for (const encuesta of data) {
          try {
            const estado = await verificarEstadoVoto(
              encuesta.id_encuesta,
              ids.fingerprint,
              ids.cookieToken
            );
            estados[encuesta.id_encuesta] = estado.ya_participo;
          } catch (err) {
            console.error(`Error al verificar estado de encuesta ${encuesta.id_encuesta}:`, err);
            estados[encuesta.id_encuesta] = false;
          }
        }
        setEstadosVoto(estados);
      } catch (err) {
        console.error('Error al cargar encuestas:', err);
        setError(
          err.response?.data?.detail || 
          'Error al cargar las encuestas. Por favor intenta nuevamente.'
        );
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return <Loading message="Cargando encuestas disponibles..." fullScreen />;
  }

  if (error) {
    return (
      <div className="home-page">
        <div className="container">
          <ErrorMessage message={error} type="error" />
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      {/* Botones flotantes para navegar entre sitios */}
      <div className="home-page-nav-buttons">
        {/* Botón Plaza de Datos */}
        <a
          href="https://www.plazadedatos.com/"
          aria-label="Ir a www.plazadedatos.com"
          className="nav-button nav-button-primary"
        >
          {/* Icono de casa */}
          <svg className="nav-button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12 3L2 12H5V21H10V15H14V21H19V12H22L12 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="nav-button-text">Plaza de Datos</span>
        </a>
        {/* Botón Encuestas */}
        <a
          href="https://encuestas.plazadedatos.com/"
          aria-label="Ir a encuestas.plazadedatos.com"
          className="nav-button nav-button-secondary"
        >
          {/* Icono de encuesta/documento */}
          <svg className="nav-button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2V8H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 13H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M16 17H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M10 9H9H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <span className="nav-button-text">Encuestas</span>
        </a>
      </div>
      <div className="container">
        <header className="home-page-header">
          <h1>Plaza Express</h1>
          <p className="home-page-subtitle">
            Participa en nuestras encuestas de forma rápida y anónima
          </p>
        </header>

        {encuestas.length === 0 ? (
          <div className="home-page-empty">
            <p>No hay encuestas disponibles en este momento.</p>
            <p className="home-page-empty-subtitle">
              Vuelve pronto para participar en nuevas encuestas.
            </p>
          </div>
        ) : (
          <div className="encuestas-grid">
            {encuestas.map((encuesta) => (
              <EncuestaCard
                key={encuesta.id_encuesta}
                {...encuesta}
                ya_participo={estadosVoto[encuesta.id_encuesta] || false}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;

